import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { GetSectorsParams, GetSectorsResponse, SectorPayload } from './types/sectors'

type ApiGetSectorsResponse = Promise<AxiosResponse<GetSectorsResponse>>
type ApiCreateSectorResponse = Promise<AxiosResponse<void>>
type ApiUpdateSectorResponse = Promise<AxiosResponse<void>>
type ApiDeleteSectorResponse = Promise<AxiosResponse<void>>
type ApiAttachCourierResponse = Promise<AxiosResponse<void>>
type ApiDetachCourierResponse = Promise<AxiosResponse<void>>

export function getSectors(params: GetSectorsParams): ApiGetSectorsResponse {
    return http.get('/dispatcher/api/sectors', { params })
}

export function createSector(payload: SectorPayload): ApiCreateSectorResponse {
    return http.post('/dispatcher/api/sectors', payload)
}

export function updateSector(sector_id: number, payload: SectorPayload): ApiUpdateSectorResponse {
    return http.put(`/dispatcher/api/sectors/${sector_id}`, payload)
}

export function deleteSector(sector_id: number): ApiDeleteSectorResponse {
    return http.delete(`/dispatcher/api/sectors/${sector_id}`)
}

export function attachCourier(sector_id: number, courier_id: number): ApiAttachCourierResponse {
    return http.post(`/dispatcher/api/sectors/${sector_id}/attach-courier`, { courierId: courier_id })
}

export function detachCourier(sector_id: number): ApiDetachCourierResponse {
    return http.delete(`/dispatcher/api/sectors/${sector_id}/detach-courier`)
}

export default {
    getSectors,
    createSector,
    updateSector,
    deleteSector,
    attachCourier,
    detachCourier
}
